import { useQuery } from '@tanstack/react-query';
import { profileApi } from '~/lib/request';
import { Language } from './types';

function useLanguages() {
  const result = useQuery({
    queryKey: ['languages'],
    queryFn: () => profileApi.get('api/common/languages').json<Language[]>(),
    throwOnError: true,
  });

  return result.data;
}

export default useLanguages;
